/** @prettier */

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router';
import devicePropTypes from '../../propTypes/device';

const RouteWithChildren = ({ routeProps, RouteComponent, childRoutes, device }) => (
  <RouteComponent {...routeProps} device={device}>
    <Switch>
      {childRoutes.map(childRoute => {
        const ChildComponent = childRoute.component;
        return (
          <Route
            key={`childRoute-${childRoute.routeProps.path}`}
            {...childRoute.routeProps}
            device={device}
            render={props => <ChildComponent {...props} device={device} />}
          />
        );
      })}
    </Switch>
  </RouteComponent>
);

RouteWithChildren.propTypes = {
  routeProps: PropTypes.shape({
    path: PropTypes.string,
  }).isRequired,
  RouteComponent: PropTypes.func.isRequired,
  childRoutes: PropTypes.arrayOf(
    PropTypes.shape({
      routeProps: PropTypes.shape({
        path: PropTypes.string,
      }),
      component: PropTypes.func,
    })
  ).isRequired,
  device: devicePropTypes.isRequired,
};

export default RouteWithChildren;
